import React, { useEffect, useState } from 'react';
// material-ui
import { Box, Button, Card, Dialog, Grid, Switch, Typography } from '@mui/material';

// project imports

import moment from 'moment';
import { currencyFormat } from 'helper/NumberFormat';
import TableComponent from 'components/TopCourtComponents/Table/TableComponent';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';

import { useNavigate } from 'react-router';
import { TypeSelectOption } from 'components/TopCourtComponents/Input/DateRangeFilter';
// import ClassFilter from './classFilter';
import { useDebounce } from 'use-debounce';
import { getTournaments } from 'services/tournamentServices';
import { Link } from 'react-router-dom';
import { getUrlCourtCode } from 'helper/Court';

const initFilter = {
  name: '',
  load: true,
  eventDateType: TypeSelectOption[0],
  eventDateStart: '',
  eventDateEnd: '',
  ageType: TypeSelectOption[0],
  ageMin: '',
  ageMax: '',
  priceType: TypeSelectOption[0],
  priceMax: '',
  priceMin: '',
  user: null,
  page: 0,
  limit: 20
}

function Tournament({

}) {

  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [showDeleteDialog, setShowDeleteDialog] = useState({
    open: false,
    data: null
  })
  const [totalData, setTotalData] = useState(0)
  const [filter, setFilter] = useState(initFilter)
  const navigate = useNavigate()

  const [debouncedFilter] = useDebounce(filter,500)

  useEffect(() => {
    (async()=>{
        if (debouncedFilter.load == true) {
            console.log('ini cek filter',filter)
            loadTournaments()   
        }
    })()
}, [debouncedFilter])

  const loadTournaments = async () => {
    setLoading(true)
    let { data, error } = await getTournaments({
      className: filter.name ? filter.name : '',
      eventDateType: filter.eventDateType ? filter.eventDateType.value : '',
      eventDateStart: filter.eventDateStart ? filter.eventDateStart : '',
      eventDateEnd: filter.eventDateEnd ? filter.eventDateEnd : '',
      ageType: filter.ageType ? filter.ageType.value : '',
      ageMin: filter.ageMin ? filter.ageMin : '',
      ageMax: filter.ageMax ? filter.ageMax : '',
      priceType: filter.priceType ? filter.priceType.value : '',
      priceMin: filter.priceMin ? filter.priceMin : '',
      priceMax: filter.priceMax ? filter.priceMax : '',
      user: filter.user ? filter.user.value : '',
      page: filter.page ? filter.page : 0,
      limit: filter.limit ? filter.limit : 0
    })
    setLoading(false)
    if (error) { console.log(error) }
    if (data) {
      console.log(data)
      setRows(data.tournaments)
      setTotalData(data.totalData)
    }
  }

  const convertHours = (hours) => {
    let hoursEnd = Number(hours.split(":")[0])
    hoursEnd += 1
    hours = hoursEnd < 10 ? `0${hoursEnd}:00` : `${hoursEnd}:00`
    return hours
  }

//   const pinClassFunction = async (row) => {
//     setLoading(true)
//     let { data, error } = await pinClass(row._id)
//     loadClasses()
//   }

//   const updateClassFunction = async (row) => {
//     setLoading(true)
//     let { data, error } = await updateClassStatus({
//       _id: row._id,
//       isActive: !row.isActive
//     })
//     loadClasses()
//   }

//   const deleteClassFunction = async (row) => {
//     setLoading(true)
//     let { data, error } = await deleteClass(row._id)
//     setShowDeleteDialog(prev => ({
//       ...prev,
//       open: false,
//       data: null
//     }))
//     loadClasses()
//   }

  const valueCustomator = (row) => {
    console.log('row info', row)
    let allowPIN = false
    if (row.dates) {
      if (moment(row.dates[row.dates.length - 1]).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
        allowPIN = true
      }
    } else if (row.date) {
      if (moment(row.date).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
        allowPIN = true
      }
    }
    return ({
      tournamentName: <Link className='span-link' to={`/${getUrlCourtCode()}/match-tournament/tournament/edit/${row._id}`}>{row.name}</Link>,
      tournamentDate: <TCLabel>{row.dates.length > 1 ? `${row.dates[0]} - ${row.dates[row.dates.length - 1]}` : row.dates[0]}</TCLabel>,
      tournamentHours: <TCLabel>{row.hour}</TCLabel>,
      registrationDeadline: <TCLabel>{moment(row.registrationDeadline).format('YYYY-MM-DD')}</TCLabel>,
      format: <TCLabel>{row.format.name}</TCLabel>,
      category: <TCLabel>{row.categories.map(v => { return `${v.tournamentCategoryId.name} (${v.totalPlayer})` }).join(", ")}</TCLabel>,
    })
  }

  const onChangeFilter = (e) => {
    setFilter(prev => ({
      ...prev,
      ...e
    }))
  }

  const onChangePage = (e) => {
    setFilter(prev => ({
        ...prev,
        ...e
    }))
  }

  const clearFilter = () => {
    setFilter(initFilter)
  }

  return (
    <>
      <Button sx={{ mb: 2 }} variant="contained" disableElevation onClick={() => {
        navigate(`/${getUrlCourtCode()}/match-tournament/tournament/add`)
      }}>Create Match & Tournament</Button>
      {/* <ClassFilter filter={filter} onChangeFilter={onChangeFilter} clearFilter={clearFilter} /> */}
      <TableComponent
        columns={[
          { label: "Tournament Name" },
          { label: "Tournament Date" },
          { label: "Tournament Hours" },
          { label: "Registration Deadline" },
          { label: "Format" },
          { label: "Category" },
        ]}
        rows={rows}
        valueCustomator={valueCustomator}
        pageChange={(e) => {
          onChangePage({page: e})
        }}
        loading={loading}
        totalData={totalData}
        page={filter.page}
        rowWidth={{
            "tournamentName": '211px',
            "tournamentDate": '182px'
        }}
      />
      <Dialog open={showDeleteDialog.open} onClose={() => {
        setShowDeleteDialog(prev => ({
            ...prev,
            open: false,
            data: null
          }))
      }}>
        <Card>
          <Grid sx={{
            p: 3
          }}>
            <Grid pb={1}>
              <TCLabel>Are you sure want to delete this tournament ?</TCLabel>
            </Grid>
            <Grid container xs={12} spacing={1} pt={1} justifyContent={"right"}>
              <Grid item>
                <Button onClick={() => { setShowDeleteDialog(prev => ({
                  ...prev,
                  open: false,
                  data: null
                })) }}>Cancel</Button>
              </Grid>
              <Grid item>
                <Button variant='contained' style={{
                  backgroundColor: '#E35480'
                }} 
                disabled={loading}
                onClick={() => { 
                //   deleteClassFunction(showDeleteDialog.data)
                }} >{"Delete"}</Button>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Dialog>
    </>
  )
}

export default Tournament;
